/**
 * @useage
 * <display-step steps="mySteps"></display-step>
 * @attribute show-all-colors : boolean
 * If true, all colors are shown. 
 * Else will show only the active color if false. The active steps is determined by isCurrentStep boolean in the steps array.
 * 
 * @attribute steps : array
 * Each object should contain "name", "color" and "isCurrentStep" for the display to show up correctly 
 * 
 */
'use strict';
import angular from 'angular';

import clusterSelectorHtmlUrl from '../views/clusterSelector.html';

angular.module('ioclusters.directives', [])

    .filter('propsFilter', function() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function(item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    })

    .directive('clusterSelector', ['$rootScope', 'ClusterService', function($rs, ClusterService) {
        return {
            restrict: 'E',
            templateUrl: clusterSelectorHtmlUrl,
            scope: {},
            controller: function($scope) {

                $scope.clusters = {};
                $scope.clusters.selectedMulti = [];
                // $scope.clusters.selectedPeople = [{ name: 'Adam New',      email: 'adam@email.com',      id: 13, country: 'United States' }];
                $scope.clusters.selectedSingle = {};
                // $scope.clusters.selectedPeople2 = { name: 'Adam Something',      email: 'adam@email.com',      id: 14, country: 'United States' };
                $scope.showClusterEdit = false;
                $scope.multiSelect = false;
                $scope.singleSelect = false;
                //The whole UI for this directive blinks when initialize. So using this one time toggle variable only during initialization.
                $rs.showClusters = false;

                $scope.accessableClusters = [];

                $scope.tagHandler = function(tag) {
                    return null;
                }

                if (!$rs.$$listenerCount['initPageCluster']) {
                    const updateCluster = $rs.$on('initPageCluster', function(event, args) {

                        $scope.accessableClusters = ClusterService.pageProperties.customClusters;
                        $scope.showClusterEdit = false;
                        if (ClusterService.pageProperties.selectType === 'multiSelect' || ClusterService.pageProperties.selectType === 'multiSelectWithAllClusters') {
                            $scope.singleSelect = false;
                            $scope.multiSelect = true;

                            $scope.clusters.selectedMulti = angular.copy(ClusterService.pageProperties.selectedClusters);
                            //ClusterService.clustersChangedInDirective($scope.clusters.selectedMulti);
                        } else { // 'singleSelect'
                            $scope.multiSelect = false;
                            $scope.singleSelect = true;
                            $scope.clusters.selectedSingle = angular.copy(ClusterService.pageProperties.selectedClusters);
                            //ClusterService.clustersChangedInDirective($scope.clusters.selectedSingle);
                        };
                        if (args.type == 'hidden') {
                            $rs.showClusters = false;
                        } else {
                            $rs.showClusters = true;
                        }
                        $scope.isClusterDisabled = ClusterService.pageProperties.isDisabled;

                    });
                    if (!$rs.showClusters) {
                        // Let the other controllers know clusterSelector is Ready
                        $rs.$broadcast('clusterSelectorReady');
                    }
                }

                $scope.$on('$destroy', function() {
                    if (updateCluster) {
                        updateCluster();
                    }
                });

                $scope.onFinishSelection = function() {
                    /*Possible Enhancement - Everytime a user selects a cluster from a multiselect,
                    the onSelectCallBack triggers which intern triggers the data call. And when the user
                    has to select  4-5 clusters or is in a page there the data is too big (Eg: Orders) the constant
                    page load is very irritating.
                    Alternative solution - Call it on the click of the close button in this directive.
                    */
                };

                /*
                 * In reporting screens to updated the cluster value when the user clicks on respective report template
                 */
                var clusterUpdated = $rs.$on('clusterChange:reporting', function(event, args) {
                    if (args.length) {
                        $scope.clusters.selectedMulti = args;
                    } else {
                        $scope.clusters.selectedMulti = [args];
                    }
                });

                $scope.$on('$destroy', function() {
                    clusterUpdated();
                });


                $scope.onSelectCallback = function(item, model, $select) {
                    if (!model) {
                        return;
                    }
                    if ($select && $select.search != "") {
                        $select.search = "";
                    }
                    if (ClusterService.pageProperties.selectType === 'multiSelect' || ClusterService.pageProperties.selectType === 'multiSelectWithAllClusters') {
                        if (item.id == 0) {
                            // What should happen when we choose multiple clusters and also choose all clusters
                        };
                        ClusterService.clustersChangedInDirective($scope.clusters.selectedMulti);
                    } else { //singleSelect
                        ClusterService.clustersChangedInDirective($scope.clusters.selectedSingle);
                    }
                };

                $scope.toggleView = function() {
                    $scope.showClusterEdit = !$scope.showClusterEdit;
                };

                $scope.removeAll = function() {
                    $scope.clusters.selectedMulti = [];
                    ClusterService.clustersChangedInDirective($scope.clusters.selectedMulti);
                };
            }
        }
    }]);